module.exports = __webpack_public_path__ + "static/media/0.6dcf9085.jpg";